import React from 'react'
import PropTypes from 'prop-types'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'

class ProductGridItemBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = {hasError: false}
    }

    static getDerivedStateFromError() {
        return {hasError: true}
    }

    componentDidCatch(error, errorInfo) {
        logger.error('[ProductGrid] Failed to render grid item', {
            message: error?.message,
            stack: error?.stack,
            componentStack: errorInfo?.componentStack,
            ...this.props.errorContext
        })
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({hasError: false})
        }
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? null
        }

        return this.props.children
    }
}

ProductGridItemBoundary.propTypes = {
    children: PropTypes.node,
    errorContext: PropTypes.object,
    fallback: PropTypes.node,
    resetKey: PropTypes.string
}

export default ProductGridItemBoundary
